// si no esta logeado dirige al login

import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; 
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private _router: Router,
    private _userService: UserService
  ){}

  canActivate(){
    let userlog = localStorage.getItem('role');

    if(userlog){
      return true;
    }else{
      this._router.navigate(['/login']);
      return false;
    }
  }
    
}

